/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Shift_Event_BackwardInputs */



/**
* | output |
* | --- |
* | "Shift Event Backward" |
*
* @param {Shortcut_Keys_Name_Shift_Event_BackwardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_shift_event_backward = /** @type {((inputs?: Shortcut_Keys_Name_Shift_Event_BackwardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Shift_Event_BackwardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decaler l'evenement vers l'arriere")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis rückwärts verschieben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta evento indietro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обратный сдвиг события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazar evento hacia atrás")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向后移动事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを後ろにシフト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना को पीछे की ओर स्थानांतरित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deslocar evento para trás")
	return /** @type {LocalizedString} */ ("Shift Event Backward")
});